/* eslint-disable */

/// <reference path="./custom.d.ts" />
/**
 * Smart symptom check connector API 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface ApiAnswer
 */
export interface ApiAnswer {
  /**
   *
   * @type {number}
   * @memberof ApiAnswer
   */
  questionId?: number;
  /**
   *
   * @type {ChoiceOption}
   * @memberof ApiAnswer
   */
  choice?: ChoiceOption;
  /**
   *
   * @type {string}
   * @memberof ApiAnswer
   */
  durationOfSymptom?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiAnswer
   */
  moreInformationAboutSymptom?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum ApiGender {
  Male = 'Male',
  Female = 'Female',
}

/**
 *
 * @export
 * @enum {string}
 */
export enum ApiLanguage {
  Fi = 'fi',
  En = 'en',
  Sv = 'sv',
}

/**
 *
 * @export
 * @enum {string}
 */
export enum ChoiceOption {
  DontKnow = 'DontKnow',
  Yes = 'Yes',
  No = 'No',
}

/**
 *
 * @export
 * @enum {string}
 */
export enum DeviceInfo {
  TerveystaloOnline = 'TerveystaloOnline',
  TerveystaloApp = 'TerveystaloApp',
}

/**
 *
 * @export
 * @interface EncryptedResultBase64
 */
export interface EncryptedResultBase64 {
  /**
   *
   * @type {string}
   * @memberof EncryptedResultBase64
   */
  aesCipher?: string | null;
  /**
   *
   * @type {string}
   * @memberof EncryptedResultBase64
   */
  aesInitializationVector?: string | null;
  /**
   *
   * @type {string}
   * @memberof EncryptedResultBase64
   */
  aesKeyRsaCipher?: string | null;
  /**
   *
   * @type {string}
   * @memberof EncryptedResultBase64
   */
  aesMode?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum EncryptedResultErrorType {
  NoResult = 'NoResult',
}

/**
 *
 * @export
 * @interface EncryptedResultRequest
 */
export interface EncryptedResultRequest {
  /**
   *
   * @type {string}
   * @memberof EncryptedResultRequest
   */
  session?: string | null;
  /**
   *
   * @type {Array<ApiAnswer>}
   * @memberof EncryptedResultRequest
   */
  answers?: Array<ApiAnswer> | null;
}
/**
 *
 * @export
 * @interface EncryptedResultResponse
 */
export interface EncryptedResultResponse {
  /**
   *
   * @type {EncryptedResultBase64}
   * @memberof EncryptedResultResponse
   */
  encryptedResultBase64?: EncryptedResultBase64;
  /**
   *
   * @type {EncryptedResultErrorType}
   * @memberof EncryptedResultResponse
   */
  error?: EncryptedResultErrorType;
  /**
   *
   * @type {string}
   * @memberof EncryptedResultResponse
   */
  patient?: string | null;
  /**
   *
   * @type {string}
   * @memberof EncryptedResultResponse
   */
  reason?: string | null;
  /**
   *
   * @type {Array<Symptom>}
   * @memberof EncryptedResultResponse
   */
  symptoms?: Array<Symptom> | null;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum ErrorType {
  ChatDetailsNotFound = 'ChatDetailsNotFound',
  ChatPermissionDenied = 'ChatPermissionDenied',
  ChatUnauthorized = 'ChatUnauthorized',
  NoResult = 'NoResult',
}

/**
 *
 * @export
 * @interface GetChatMetadataRequest
 */
export interface GetChatMetadataRequest {
  /**
   *
   * @type {ApiLanguage}
   * @memberof GetChatMetadataRequest
   */
  language?: ApiLanguage;
  /**
   *
   * @type {number}
   * @memberof GetChatMetadataRequest
   */
  chatId?: number;
  /**
   *
   * @type {DeviceInfo}
   * @memberof GetChatMetadataRequest
   */
  deviceInfo?: DeviceInfo;
  /**
   * Must be one of the values returned from chat options endpoint.
   * @type {string}
   * @memberof GetChatMetadataRequest
   */
  reason?: string | null;
}
/**
 *
 * @export
 * @interface GetChatMetadataResponse
 */
export interface GetChatMetadataResponse {
  /**
   *
   * @type {string}
   * @memberof GetChatMetadataResponse
   */
  chatSecureMetadata?: string | null;
}
/**
 *
 * @export
 * @interface GetChatOptionsResponse
 */
export interface GetChatOptionsResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GetChatOptionsResponse
   */
  items?: Array<string> | null;
}
/**
 *
 * @export
 * @interface GetKeywordsResponse
 */
export interface GetKeywordsResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof GetKeywordsResponse
   */
  keywords?: Array<string> | null;
}
/**
 *
 * @export
 * @interface Question
 */
export interface Question {
  /**
   *
   * @type {number}
   * @memberof Question
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Question
   */
  text?: string | null;
  /**
   *
   * @type {string}
   * @memberof Question
   */
  instruction?: string | null;
  /**
   *
   * @type {string}
   * @memberof Question
   */
  details?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof Question
   */
  askDurationOfSymptom?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Question
   */
  askMoreInformationAboutSymptom?: boolean;
}
/**
 *
 * @export
 * @interface QuestionRequest
 */
export interface QuestionRequest {
  /**
   *
   * @type {string}
   * @memberof QuestionRequest
   */
  session?: string | null;
  /**
   *
   * @type {Array<ApiAnswer>}
   * @memberof QuestionRequest
   */
  answers?: Array<ApiAnswer> | null;
  /**
   *
   * @type {ApiLanguage}
   * @memberof QuestionRequest
   */
  language?: ApiLanguage;
}
/**
 *
 * @export
 * @interface QuestionResponse
 */
export interface QuestionResponse {
  /**
   *
   * @type {string}
   * @memberof QuestionResponse
   */
  session?: string | null;
  /**
   *
   * @type {Question}
   * @memberof QuestionResponse
   */
  question?: Question;
}
/**
 *
 * @export
 * @interface ResultRequest
 */
export interface ResultRequest {
  /**
   *
   * @type {string}
   * @memberof ResultRequest
   */
  session?: string | null;
  /**
   *
   * @type {Array<ApiAnswer>}
   * @memberof ResultRequest
   */
  answers?: Array<ApiAnswer> | null;
  /**
   *
   * @type {number}
   * @memberof ResultRequest
   */
  chatId?: number;
  /**
   *
   * @type {DeviceInfo}
   * @memberof ResultRequest
   */
  deviceInfo?: DeviceInfo;
}
/**
 *
 * @export
 * @interface ResultResponse
 */
export interface ResultResponse {
  /**
   *
   * @type {string}
   * @memberof ResultResponse
   */
  chatSecureMetadata?: string | null;
  /**
   *
   * @type {ErrorType}
   * @memberof ResultResponse
   */
  error?: ErrorType;
  /**
   *
   * @type {string}
   * @memberof ResultResponse
   */
  patient?: string | null;
  /**
   *
   * @type {string}
   * @memberof ResultResponse
   */
  reason?: string | null;
  /**
   *
   * @type {Array<Symptom>}
   * @memberof ResultResponse
   */
  symptoms?: Array<Symptom> | null;
}
/**
 *
 * @export
 * @interface StartRequest
 */
export interface StartRequest {
  /**
   *
   * @type {ApiLanguage}
   * @memberof StartRequest
   */
  language?: ApiLanguage;
  /**
   * Must be one of the values returned from keywords endpoint.
   * @type {Array<string>}
   * @memberof StartRequest
   */
  symptoms?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof StartRequest
   */
  additionalInformation?: string | null;
  /**
   *
   * @type {ApiGender}
   * @memberof StartRequest
   */
  gender?: ApiGender;
  /**
   *
   * @type {number}
   * @memberof StartRequest
   */
  age?: number | null;
}
/**
 *
 * @export
 * @interface StartResponse
 */
export interface StartResponse {
  /**
   * Null, when there are no questions available.
   * @type {string}
   * @memberof StartResponse
   */
  session?: string | null;
  /**
   * \"Zero or more questions, depending on given symptoms.\"
   * @type {Array<Question>}
   * @memberof StartResponse
   */
  questions?: Array<Question> | null;
}
/**
 *
 * @export
 * @interface Symptom
 */
export interface Symptom {
  /**
   *
   * @type {string}
   * @memberof Symptom
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof Symptom
   */
  text?: string | null;
}

/**
 * HtaApi - axios parameter creator
 * @export
 */
export const HtaApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get options that bypass smart health check.
     * @param {ApiLanguage} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAlternativeOptions(language: ApiLanguage, options: any = {}): RequestArgs {
      // verify required parameter 'language' is not null or undefined
      if (language === null || language === undefined) {
        throw new RequiredError(
          'language',
          'Required parameter language was null or undefined when calling getAlternativeOptions.',
        );
      }
      const localVarPath = `/chat/options/{language}`.replace(`{${'language'}}`, encodeURIComponent(String(language)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function' ? configuration.apiKey('api-key') : configuration.apiKey;
        localVarHeaderParameter['api-key'] = localVarApiKeyValue;
      }

      // authentication Auth0 required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken('Auth0', ['openid', 'userguid'])
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + localVarAccessTokenValue;
      }

      // authentication apiKeyHeader required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Ocp-Apim-Subscription-Key')
            : configuration.apiKey;
        localVarHeaderParameter['Ocp-Apim-Subscription-Key'] = localVarApiKeyValue;
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get chat metadata without smart symptom check.
     * @param {GetChatMetadataRequest} [GetChatMetadataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChatMetadata(GetChatMetadataRequest?: GetChatMetadataRequest, options: any = {}): RequestArgs {
      const localVarPath = `/chat/data`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function' ? configuration.apiKey('api-key') : configuration.apiKey;
        localVarHeaderParameter['api-key'] = localVarApiKeyValue;
      }

      // authentication Auth0 required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken('Auth0', ['openid', 'userguid'])
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + localVarAccessTokenValue;
      }

      // authentication apiKeyHeader required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Ocp-Apim-Subscription-Key')
            : configuration.apiKey;
        localVarHeaderParameter['Ocp-Apim-Subscription-Key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
      const needsSerialization =
        <any>'GetChatMetadataRequest' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(GetChatMetadataRequest !== undefined ? GetChatMetadataRequest : {})
        : GetChatMetadataRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get smart symptom check result encrypted with client\'s public key.
     * @param {EncryptedResultRequest} [EncryptedResultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEncryptedResult(EncryptedResultRequest?: EncryptedResultRequest, options: any = {}): RequestArgs {
      const localVarPath = `/encryptedResult`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function' ? configuration.apiKey('api-key') : configuration.apiKey;
        localVarHeaderParameter['api-key'] = localVarApiKeyValue;
      }

      // authentication Auth0 required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken('Auth0', ['openid', 'userguid'])
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + localVarAccessTokenValue;
      }

      // authentication apiKeyHeader required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Ocp-Apim-Subscription-Key')
            : configuration.apiKey;
        localVarHeaderParameter['Ocp-Apim-Subscription-Key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
      const needsSerialization =
        <any>'EncryptedResultRequest' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(EncryptedResultRequest !== undefined ? EncryptedResultRequest : {})
        : EncryptedResultRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get keywords to use as symptoms on smart symptom check.
     * @param {ApiLanguage} language
     * @param {string} [query] Prefix query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKeywords(language: ApiLanguage, query?: string, options: any = {}): RequestArgs {
      // verify required parameter 'language' is not null or undefined
      if (language === null || language === undefined) {
        throw new RequiredError(
          'language',
          'Required parameter language was null or undefined when calling getKeywords.',
        );
      }
      const localVarPath = `/keywords/{language}`.replace(`{${'language'}}`, encodeURIComponent(String(language)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function' ? configuration.apiKey('api-key') : configuration.apiKey;
        localVarHeaderParameter['api-key'] = localVarApiKeyValue;
      }

      // authentication Auth0 required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken('Auth0', ['openid', 'userguid'])
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + localVarAccessTokenValue;
      }

      // authentication apiKeyHeader required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Ocp-Apim-Subscription-Key')
            : configuration.apiKey;
        localVarHeaderParameter['Ocp-Apim-Subscription-Key'] = localVarApiKeyValue;
      }

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get additional question based on current answers. Can be called multiple times with more answers.
     * @param {QuestionRequest} [QuestionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestion(QuestionRequest?: QuestionRequest, options: any = {}): RequestArgs {
      const localVarPath = `/question`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function' ? configuration.apiKey('api-key') : configuration.apiKey;
        localVarHeaderParameter['api-key'] = localVarApiKeyValue;
      }

      // authentication Auth0 required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken('Auth0', ['openid', 'userguid'])
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + localVarAccessTokenValue;
      }

      // authentication apiKeyHeader required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Ocp-Apim-Subscription-Key')
            : configuration.apiKey;
        localVarHeaderParameter['Ocp-Apim-Subscription-Key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
      const needsSerialization =
        <any>'QuestionRequest' !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(QuestionRequest !== undefined ? QuestionRequest : {})
        : QuestionRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get smart symptom check result for Ninchat.
     * @param {ResultRequest} [ResultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResult(ResultRequest?: ResultRequest, options: any = {}): RequestArgs {
      const localVarPath = `/result`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function' ? configuration.apiKey('api-key') : configuration.apiKey;
        localVarHeaderParameter['api-key'] = localVarApiKeyValue;
      }

      // authentication Auth0 required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken('Auth0', ['openid', 'userguid'])
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + localVarAccessTokenValue;
      }

      // authentication apiKeyHeader required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Ocp-Apim-Subscription-Key')
            : configuration.apiKey;
        localVarHeaderParameter['Ocp-Apim-Subscription-Key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
      const needsSerialization =
        <any>'ResultRequest' !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(ResultRequest !== undefined ? ResultRequest : {})
        : ResultRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create new session and fetch questions
     * @param {StartRequest} [StartRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start(StartRequest?: StartRequest, options: any = {}): RequestArgs {
      const localVarPath = `/start`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication ApiKey required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function' ? configuration.apiKey('api-key') : configuration.apiKey;
        localVarHeaderParameter['api-key'] = localVarApiKeyValue;
      }

      // authentication Auth0 required
      // oauth required
      if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken('Auth0', ['openid', 'userguid'])
            : configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + localVarAccessTokenValue;
      }

      // authentication apiKeyHeader required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Ocp-Apim-Subscription-Key')
            : configuration.apiKey;
        localVarHeaderParameter['Ocp-Apim-Subscription-Key'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
      const needsSerialization =
        <any>'StartRequest' !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(StartRequest !== undefined ? StartRequest : {})
        : StartRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HtaApi - functional programming interface
 * @export
 */
export const HtaApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get options that bypass smart health check.
     * @param {ApiLanguage} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAlternativeOptions(
      language: ApiLanguage,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatOptionsResponse> {
      const localVarAxiosArgs = HtaApiAxiosParamCreator(configuration).getAlternativeOptions(language, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get chat metadata without smart symptom check.
     * @param {GetChatMetadataRequest} [GetChatMetadataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChatMetadata(
      GetChatMetadataRequest?: GetChatMetadataRequest,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatMetadataResponse> {
      const localVarAxiosArgs = HtaApiAxiosParamCreator(configuration).getChatMetadata(GetChatMetadataRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get smart symptom check result encrypted with client\'s public key.
     * @param {EncryptedResultRequest} [EncryptedResultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEncryptedResult(
      EncryptedResultRequest?: EncryptedResultRequest,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncryptedResultResponse> {
      const localVarAxiosArgs = HtaApiAxiosParamCreator(configuration).getEncryptedResult(
        EncryptedResultRequest,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get keywords to use as symptoms on smart symptom check.
     * @param {ApiLanguage} language
     * @param {string} [query] Prefix query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKeywords(
      language: ApiLanguage,
      query?: string,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetKeywordsResponse> {
      const localVarAxiosArgs = HtaApiAxiosParamCreator(configuration).getKeywords(language, query, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get additional question based on current answers. Can be called multiple times with more answers.
     * @param {QuestionRequest} [QuestionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestion(
      QuestionRequest?: QuestionRequest,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionResponse> {
      const localVarAxiosArgs = HtaApiAxiosParamCreator(configuration).getQuestion(QuestionRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get smart symptom check result for Ninchat.
     * @param {ResultRequest} [ResultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResult(
      ResultRequest?: ResultRequest,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultResponse> {
      const localVarAxiosArgs = HtaApiAxiosParamCreator(configuration).getResult(ResultRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Create new session and fetch questions
     * @param {StartRequest} [StartRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start(
      StartRequest?: StartRequest,
      options?: any,
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartResponse> {
      const localVarAxiosArgs = HtaApiAxiosParamCreator(configuration).start(StartRequest, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * HtaApi - factory interface
 * @export
 */
export const HtaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @summary Get options that bypass smart health check.
     * @param {ApiLanguage} language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAlternativeOptions(language: ApiLanguage, options?: any) {
      return HtaApiFp(configuration).getAlternativeOptions(language, options)(axios, basePath);
    },
    /**
     *
     * @summary Get chat metadata without smart symptom check.
     * @param {GetChatMetadataRequest} [GetChatMetadataRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getChatMetadata(GetChatMetadataRequest?: GetChatMetadataRequest, options?: any) {
      return HtaApiFp(configuration).getChatMetadata(GetChatMetadataRequest, options)(axios, basePath);
    },
    /**
     *
     * @summary Get smart symptom check result encrypted with client\'s public key.
     * @param {EncryptedResultRequest} [EncryptedResultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEncryptedResult(EncryptedResultRequest?: EncryptedResultRequest, options?: any) {
      return HtaApiFp(configuration).getEncryptedResult(EncryptedResultRequest, options)(axios, basePath);
    },
    /**
     *
     * @summary Get keywords to use as symptoms on smart symptom check.
     * @param {ApiLanguage} language
     * @param {string} [query] Prefix query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKeywords(language: ApiLanguage, query?: string, options?: any) {
      return HtaApiFp(configuration).getKeywords(language, query, options)(axios, basePath);
    },
    /**
     *
     * @summary Get additional question based on current answers. Can be called multiple times with more answers.
     * @param {QuestionRequest} [QuestionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestion(QuestionRequest?: QuestionRequest, options?: any) {
      return HtaApiFp(configuration).getQuestion(QuestionRequest, options)(axios, basePath);
    },
    /**
     *
     * @summary Get smart symptom check result for Ninchat.
     * @param {ResultRequest} [ResultRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResult(ResultRequest?: ResultRequest, options?: any) {
      return HtaApiFp(configuration).getResult(ResultRequest, options)(axios, basePath);
    },
    /**
     *
     * @summary Create new session and fetch questions
     * @param {StartRequest} [StartRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start(StartRequest?: StartRequest, options?: any) {
      return HtaApiFp(configuration).start(StartRequest, options)(axios, basePath);
    },
  };
};

/**
 * HtaApi - object-oriented interface
 * @export
 * @class HtaApi
 * @extends {BaseAPI}
 */
export class HtaApi extends BaseAPI {
  /**
   *
   * @summary Get options that bypass smart health check.
   * @param {ApiLanguage} language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HtaApi
   */
  public getAlternativeOptions(language: ApiLanguage, options?: any) {
    return HtaApiFp(this.configuration).getAlternativeOptions(language, options)(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get chat metadata without smart symptom check.
   * @param {GetChatMetadataRequest} [GetChatMetadataRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HtaApi
   */
  public getChatMetadata(GetChatMetadataRequest?: GetChatMetadataRequest, options?: any) {
    return HtaApiFp(this.configuration).getChatMetadata(GetChatMetadataRequest, options)(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get smart symptom check result encrypted with client\'s public key.
   * @param {EncryptedResultRequest} [EncryptedResultRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HtaApi
   */
  public getEncryptedResult(EncryptedResultRequest?: EncryptedResultRequest, options?: any) {
    return HtaApiFp(this.configuration).getEncryptedResult(EncryptedResultRequest, options)(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get keywords to use as symptoms on smart symptom check.
   * @param {ApiLanguage} language
   * @param {string} [query] Prefix query
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HtaApi
   */
  public getKeywords(language: ApiLanguage, query?: string, options?: any) {
    return HtaApiFp(this.configuration).getKeywords(language, query, options)(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get additional question based on current answers. Can be called multiple times with more answers.
   * @param {QuestionRequest} [QuestionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HtaApi
   */
  public getQuestion(QuestionRequest?: QuestionRequest, options?: any) {
    return HtaApiFp(this.configuration).getQuestion(QuestionRequest, options)(this.axios, this.basePath);
  }

  /**
   *
   * @summary Get smart symptom check result for Ninchat.
   * @param {ResultRequest} [ResultRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HtaApi
   */
  public getResult(ResultRequest?: ResultRequest, options?: any) {
    return HtaApiFp(this.configuration).getResult(ResultRequest, options)(this.axios, this.basePath);
  }

  /**
   *
   * @summary Create new session and fetch questions
   * @param {StartRequest} [StartRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HtaApi
   */
  public start(StartRequest?: StartRequest, options?: any) {
    return HtaApiFp(this.configuration).start(StartRequest, options)(this.axios, this.basePath);
  }
}
